// OAuth's deletion hook is authoritative for credential availability, including
// BroadcastChannel notifications from other tabs. Never interpret network errors
// as session deletion or try to refresh/recreate a deleted credential implicitly.
export const SESSION_ENDED_NOTICE = "Your sign-in session ended. Sign in again to load your sites.";

export function sessionLifecycle(options: {
  currentDid: () => string | undefined;
  onLost: (did: string) => void;
}) {
  let pendingRestore: Set<string> | undefined;
  return {
    /** Register before init(): deletion can race a restored-session result even
     * without a local identity hint. Completing restore releases this bookkeeping. */
    beginRestore() {
      const deleted = new Set<string>();
      pendingRestore = deleted;
      return (did: string | undefined): boolean => {
        if (pendingRestore === deleted) pendingRestore = undefined;
        return did === undefined || !deleted.has(did);
      };
    },
    onDelete(did: string) {
      pendingRestore?.add(did);
      if (options.currentDid() === did) options.onLost(did);
    },
  };
}
